import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Table as ReactTable } from '@tanstack/react-table';
import { flexRender } from "@tanstack/react-table";
import { IDraft, IErrorReturn, IResumeCard } from '@/lib/interfaces';
import { draftColumns } from '@/lib/tables-defs';
import Image from 'next/image';
import LoadingGif from '@/../public/loading.gif';

interface ITableBlock {
  isLoading: boolean | null,
  dataFetched: boolean,
  table: ReactTable<IDraft | IErrorReturn> | ReactTable<IResumeCard | IErrorReturn>
}

function TableBlock({ isLoading, table, dataFetched }: ITableBlock) {
  return (
    <div className="overflow-hidden rounded-md border">
      <Table>
        <TableHeader className='bg-indigo-400 text-white'>
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <TableHead key={header.id} className='text-white'>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                        header.column.columnDef.header as string,
                        header.getContext()
                      )}
                  </TableHead>
                )
              })}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.length == 0 && !dataFetched ? (
            <TableRow>
              <TableCell
                colSpan={draftColumns.length}
                className="h-24 text-center"
              >
                <div className='w-full text-center flex flex-row justify-center items-center'>
                  {isLoading ?
                    <Image src={LoadingGif} alt={'Loading Data'} width={40} /> :
                    <span>No Results</span>
                  }

                </div>
              </TableCell>
            </TableRow>
          ) : (
            table.getRowModel().rows.map((row, i) => (
              <TableRow className={i % 2 == 1 ? 'bg-indigo-100' : ''}
                key={row.id}
                data-state={row.getIsSelected() && "selected"}
              >
                {row.getVisibleCells().map((cell) => (
                  <TableCell key={cell.id}
                    className={cell.id.includes('actions') 
                        ? 'w-full flex flex-row justify-end items-center'
                        : ''}>
                    {flexRender(
                      cell.column.columnDef.cell as string,
                      cell.getContext()
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  )
}

export default TableBlock